import './AppHeader.css';
import logo from './icon.ico';
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Header() {
  const [currentDate, setCurrentDate] = useState(new Date());
  const location = useLocation();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000);
    
    return () => clearInterval(timer);
  }, []);

  const options = {
    hour: 'numeric', 
    minute: 'numeric', 
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  };

  const isActive = (path) => location.pathname === path;

  return(
    <header>
      <Link 
        to="/" className={isActive('/') ? 'active' : ''}>
        <img src={logo} alt="Логотип" />
      </Link>
      <div>
        <nav>
          <ul>
            <li>
              <Link 
                to="/" className={isActive('/') ? 'active' : ''}>
                Полное расписание
              </Link>
            </li>
            <li>
              <Link 
                to="/students" className={isActive('/students') ? 'active' : ''}>
                Расписание занятий студентов
              </Link>
            </li>
            <li>
              <Link 
                to="/teachers" className={isActive('/teachers') ? 'active' : ''}>
                Расписание занятий преподавателей
              </Link>
            </li>
            <li>
              <Link 
                to="/classroom" className={isActive('/classroom') ? 'active' : ''}>
                Расписание занятий в аудиториях
              </Link>
            </li>
          <li>
          <Link to="/exams" className={isActive('/exams') ? 'active' : ''}>
            Расписание сессии
          </Link>
          </li>
          <li>
          <Link to="/archive" className={isActive('/archive') ? 'active' : ''}>
            Архив расписания
          </Link>
          </li>
          </ul>
        </nav>
      </div>
      <span>{currentDate.toLocaleDateString('ru-RU', options)}</span> 
    </header>
  );
}

export default Header;